import React from 'react'
import NextImage from 'next/image'

import { Button } from '@wartek-id/button-v1'
import {
  Dialog,
  DialogContent,
  DialogCloseButton,
  DialogOverlay,
} from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

type TDialogPelaksanaanAppealApprovedProps = {
  isOpen: boolean
  onClose: () => void
}
export const DialogPelaksanaanAppealApproved: React.FC<
  TDialogPelaksanaanAppealApprovedProps
> = ({ isOpen, onClose }) => {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
      autoFocus={false}
      returnFocus={false}
    >
      <DialogOverlay />
      <DialogContent>
        <div className="p-6 space-y-4">
          <NextImage
            src="/illustrations/img-reflection-documents-magnifying-glass.png"
            width={84}
            height={84}
          />

          <div className="space-y-4">
            <Text variant="display-sm">Pengajuan perubahan diterima</Text>
            <Text variant="body-lg" color="subdued">
              Setelah Pengawas Sekolah selesai mengubah pengisian, Anda dapat
              mengulang hasil pemantauan Anda.
            </Text>
          </div>

          <div className="flex space-x-5">
            <Button
              data-testid="appeal-submitted-back-button"
              onClick={onClose}
              color="blue"
              size="lg"
              fullWidth
            >
              Saya mengerti
            </Button>
          </div>
        </div>
        <DialogCloseButton />
      </DialogContent>
    </Dialog>
  )
}
